// Version : 1.0.0
// Author : AGALYA

import VoterIdDetailsActionType from './voter-id-details.types';

/** ***************** UPDATE VOTER ID START ************************/
export const updateVoterIdStart = (voterIdCredentials: any) => ({
	type: VoterIdDetailsActionType.UPDATE_VOTER_ID_START,
	payload: voterIdCredentials,
});

export const updateVoterIdSuccess = (voterIdSuccess: any) => ({
	type: VoterIdDetailsActionType.UPDATE_VOTER_ID_SUCCESS,
	payload: voterIdSuccess,
});

export const updateVoterIdFailure = (voterIdFailure: any) => ({
	type: VoterIdDetailsActionType.UPDATE_VOTER_ID_FAILURE,
	payload: voterIdFailure,
});

export const updateVoterIdResponseResetStart = () => ({
	type: VoterIdDetailsActionType.UPDATE_VOTER_ID_RESPONSE_REST_START,
});

export const updateVoterIdResponseChanged = () => ({
	type: VoterIdDetailsActionType.UPDATE_VOTER_ID_RESPONSE_CHANGED,
});
/** ***************** UPDATE VOTER ID END ************************/
